<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="类型筛选">
          <el-button-group>
            <el-button @click="changeTypeFunc('')">不限</el-button>
            <el-button :type="formInline.type == item.key_name ? 'primary' : ''" plain v-for="(item, index) in typeData.type" :key="index" @click="changeTypeFunc(item.key_name)">{{item.name}}</el-button>
          </el-button-group>
        </el-form-item>
        
        <el-form-item label="分类">
          <el-cascader size="small" v-model="formInline.category_ids" clearable :options="cateList" :props="propsParam" @change="handleChange"></el-cascader>
        </el-form-item>
        <br>
        <el-form-item label="关键字">
          <el-input v-model="formInline.keyword" placeholder="请输入问题或解析" clearable></el-input>
        </el-form-item>
        <el-form-item label="ID">
          <el-input v-model="formInline.question_id" placeholder="请输入ID" clearable style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="答案类型">
          <el-select v-model="formInline.answer_type" placeholder="请选择" clearable>
            <el-option label="不限" value="0"></el-option>
            <el-option v-for="(item,index) in typeData.answer_type" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="类型">
          <el-select size="small" v-model="formInline.type" clearable placeholder="类型选择" @change="typeChange">
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(item, index) in typeData.type" :key="index" :label="item.name" :value="item.key_name"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option label="不限" value=""></el-option>
            <el-option label="有效" value="1"></el-option>
            <el-option label="无效" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="添加日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="d-s-c">
      <el-button size="small" type="primary" @click="openPopup('add')" icon="el-icon-plus">添加</el-button>
      <el-button size="small" type="success" @click="openPopup('import')" icon="el-icon-plus" v-if="formInline.type != 20">导入</el-button>
      <el-button size="small" type="primary" @click="openPopup('batch')" icon="el-icon-check">批量操作</el-button>
      <span class="ml10">打开拖动并更新排序：<el-switch v-model="isSaveSort" @change="onSaveSort"></el-switch></span> 
    </div>

    <!--内容-->
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" ref="dragTable" highlight-current-row border style="width: 100%" v-loading="loading"
         @sort-change="sortChange" :row-key="getRowKey"  @selection-change="tableCurrentChange">
          <el-table-column type="selection" :reserve-selection="true" align="center" width="45"></el-table-column>
          <el-table-column prop="question_id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="sort" label="排序" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="type" label="类型" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.type">{{ typeData.type[scope.row.type].name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="category_str" label="分类"></el-table-column>
          <el-table-column prop="question" label="问题">
            <template slot-scope="scope">
              <p v-html="scope.row.question"></p>
              <!-- <p v-search="{searchValue:formInline.keyword,message:scope.row.question}" v-html="scope.row.question"></p> -->
            </template>
          </el-table-column>
          <el-table-column prop="answer_type" label="答案类型" width="80" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.answer_type">{{ typeData.answer_type[scope.row.answer_type].name }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="得分" width="80" align="center" sortable="custom"></el-table-column>
          
          <el-table-column prop="status" label="状态" width="60">
            <template slot-scope="scope">
              <span class="" v-if="scope.row.status">有效</span>
              <span class="gray9" v-else>无效</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140" sortable="custom"></el-table-column>
          <el-table-column prop="name" label="操作" width="130" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openPopup('edit', scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-if="scope.row.path!='/plus'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <Add v-if="show_popup['add']" :open_add="show_popup['add']" :typeData="typeData" :selectModel="selectModel" :tags="tags" :type="formInline.type" :category_ids="formInline.category_ids" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--编辑-->
    <Edit v-if="show_popup['edit']" :open_edit="show_popup['edit']" :typeData="typeData" :selectModel="selectModel" :tags="tags" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

    <!--添加-->
    <Import v-if="show_popup['import']" :open_import="show_popup['import']" :cateList="cateList" :type="formInline.type" :category_ids="formInline.category_ids" @closeDialog="closeDialogFunc($event, 'import')"></Import>

    <!--批量-->
    <Batch v-if="show_popup['batch']" :is_open="show_popup['batch']" :ids="ids" :cateList="cateList" :category_ids="formInline.category_ids" @closeDialog="closeDialogFunc($event, 'batch')"></Batch>
  </div>
</template>

<script>
  import QuestionLibraryApi from '@/api/study/question_library.js';
  import CategoryApi from '@/api/study/category.js';
  import Edit from './part/Edit.vue';
  import Add from './part/Add';
  import Import from './part/Import';
  import Batch from './part/Batch';
  import { deepClone } from '@/utils/base.js';
  import Sortable from 'sortablejs'
  export default {
    components: {
      /*编辑组件*/
      Edit,
      Add,
      Import,
      Batch,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        // sortName: 'sort',
        // sortValue: 'ascending',
        formInline: {
          type: 0,
          keyword: '',
          question_id: '',
          answer_type: '',
          create_time: '',
          category_ids: '',
          package_id: '',
          status: ''
        },
        /*时间*/
        create_time: '',
        /*等级*/
        grade:[],
        /*弹窗*/
        show_popup: {
          add: false,
          edit: false,
          import: false,
          batch: false,
        },
        /*选中的对象*/
        selectModel:{},
        typeData: [],
        /*展示数据*/
        propsParam: {
          label: 'name',
          value: 'category_id',
          checkStrictly: true
        },
        /*分类*/
        cateList: [],
        /*当前父集ID*/
        parentsVal: [],
        multipleSelection: [],
        ids: [],
        tags: [],
        isSaveSort: false,
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);
      if (params.shuati_id || params.question_id){
      }else{
        // 默认
        let type = this.$db.getRouteField(this, 'type');
        if (type) this.formInline.type = type;

        let category_ids = this.$db.getRouteField(this, 'category_ids');
        if (category_ids) this.formInline.category_ids = category_ids;
      }

      this.getTableList();

    },
    methods: {
      /**
       * 开关按钮
       */
      onSaveSort(e){
        if (e){
          this.setSort();
          this.sortChange({prop:'sort', order: 'ascending'});
          this.$refs.dragTable.sort('sort', 'ascending');
        } 
      },
      /**
       * 保存排序
       */
      saveSort(data){
        if (!this.isSaveSort) return;
        CategoryApi.saveSort({data:data}, true);
      },
      /**
       * 排序方法
       */
      setSort(){
        const el = this.$refs.dragTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
        const self = this
        this.sortable = Sortable.create(el,{
          animation: 250,
           onEnd: ({ newIndex, oldIndex }) => {
            const num = (self.curPage-1) * self.pageSize;
            const oldItem = self.tableData[oldIndex]
            const newItem = self.tableData[newIndex]
            oldItem.sort = newIndex+num;
            newItem.sort = oldIndex+num;
            self.tableData.splice(oldIndex, 1)
            self.tableData.splice(newIndex, 0, oldItem)
            self.saveSort([{
              question_id:oldItem.question_id,
              new_index: newIndex+num,
            },{
              question_id:newItem.question_id,
              new_index: oldIndex+num,
            }]);
          }
        })
      },
      // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
      getRowKey (row) {
        return row.question_id;
      },
      /*监听复选按钮选中事件*/
      tableCurrentChange(val) {
        this.multipleSelection = val;
        this.ids = [];
        val.forEach(e => {
          this.ids.push(e.question_id);
        });
      },
      /*选择类型*/
      typeChange(){
          let self = this;
          CategoryApi.getList({type:this.formInline.type}, true).then(res => {
              if (res.code == 1) {
                  self.cateList = res.data.list
              }
          });
      },
      /*选择分类*/
      handleChange(e) {
        this.curPage = 1;
        this.$db.setRoute(this, {type:this.formInline.type, category_ids:this.formInline.category_ids});
        this.onSubmit();
        this.ids = [];
        this.$refs.dragTable.clearSelection();
      },
      /*跳转订单详情*/
      gotoPage(row) {
        let self = this;
        this.$router.push({
          path: '/order/order/detail',
          query: {
            order_id: row.order_id
          }
        });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        QuestionLibraryApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.totalDataNumber = data.list.total;
          self.typeData = {
            type: data.type,
            category: data.category,
            answer_type: data.answer_type,
          };
          self.tags = data.tags;
          self.cateList = data.category;
          self.cateList.unshift({name:'顶级',category_id:0});
          this.findParentsID(this.cateList);
        }).catch(error => {
          self.loading = false;
        });
      },

      /*查找父集id*/
      findParentsID(list){
        let flag=false;
        for(let i=0;i<list.length;i++){
          let item=list[i];
          if(item.category_id==this.formData.category_id){
            this.parentsVal.unshift(item.category_id);
            flag=true;
            break;
          }else{
            let children=item.children;
            if(typeof children!='undefined'&&children.length>0){
                if(this.findParentsID(children)){
                  this.parentsVal.unshift(item.category_id);
                  flag=true;
                  break;
                }
            }
          }
        }
        return flag;
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
        this.ids = [];
        this.$refs.dragTable.clearSelection();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.show_popup[name] = true;
        if (item) this.selectModel = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },
      /*选择类型*/
      changeTypeFunc(e){
        this.curPage = 1;
        this.formInline.type = e;
        this.formInline.category_ids = [];
        this.$db.setRoute(this, {'type': e, 'category_ids': []});
        this.getTableList();
        this.ids = [];
        this.$refs.dragTable.clearSelection();
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            QuestionLibraryApi.del({question_id: row.question_id},true)
              .then(data => {
                if (data.code == 1) {
                  self.loading = false;
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.getTableList();
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {});
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/questionlibrary/index.vue